import { z } from "zod";

export const staffBookingPatientContextSchema = z.object({
  lastAppointmentStateId: z.number().nullish().catch(null),
  patientRegistrations: z
    .array(
      z.object({
        providerGroup: z.object({ id: z.string(), name: z.string() }),
        stateIds: z.array(z.number()).nullish().catch(null),
      }),
    )
    .nullish()
    .catch(null),
});

export type StaffBookingPatientContext = z.infer<
  typeof staffBookingPatientContextSchema
>;

export type StaffBookingRegistration = NonNullable<
  StaffBookingPatientContext["patientRegistrations"]
>[number];
